// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__a0BDC","icon":"SortAdornment_icon__fFEzR","up":"SortAdornment_up__3Qz51","down":"SortAdornment_down__fVsjr","active":"SortAdornment_active__1_pJm"};